import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { useAuth } from "../context/AuthContext";
import RecentFiles from "../components/RecentFiles";
import Shortcuts from "../components/Shortcuts";
import { useLoading } from "../context/LoadingContext";
import useApi from "../utils/useApi";
import Toaster, { ToastContainerComponent } from "../components/Toaster"; // ✅ Toaster for notifications
import Notification from "../components/NotificationList";

const Dashboard = () => {
  const { user } = useAuth();
  const { setLoading } = useLoading();
  const { callApi } = useApi();
  const [recentfolders, setRecentfolders] = useState([]);
  const [recentnotifications, setRecentNotifications] = useState([]);
  // console.log("user", user);

  // ✅ Fetch folders from API
  const fetchRecentFolder = async () => {
    setLoading(true);
    try {
      const params = {
        page: 1,
        length: 10,
        sort: "desc",
      };
      //const response = await callApi({ endpoint: "/admin/directories/get-sub-directory", params });
      const isClient = user?.user_role?.toLowerCase() === "client";
      console.log(isClient);
       const endpoint = isClient
        ? "/client/shared-folders"
        : "/admin/directories/get-sub-directory";

      const response = await callApi ({endpoint, params});

      if (response?.success) {
        const foldersData = isClient
          ? response.data.sharedFolders || []
          : response.data.directories || [];

        setRecentfolders(foldersData);
      } else {
        Toaster.error("Failed to load folders."); // ✅ Using Toaster for errors
      }
    } catch (error) {
      console.error("Error fetching folders:", error);
      Toaster.error("Error fetching folders. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchNotification = async () => {
    setLoading(true);
    try {
      const params = {
        status: "unread",
        page: 1,
        length: 10,
        sort: "desc",
      };
      const response = await callApi({ endpoint: "/client/get-notifications", params });
      console.log("notification...",response);

      if (response?.success) {
        setRecentNotifications(response.data);
      } else {
        Toaster.error("Failed to load folders."); // ✅ Using Toaster for errors
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      Toaster.error("Error fetching notifications. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecentFolder();
    fetchNotification();
  }, []);

  return (
    <MainLayout>
      {/* Dashboard-specific content */}
      <ToastContainerComponent />
      <div className="inner_full_right_part">
        <div className="row">
          {/* User Welcome Section */}
          <div className="col-md-12">
            <div className="user_det">
              <div className="user_image">
                <span>
                  {user?.user_name
                    ?.split(" ") // Split the full name into words
                    .map((word) => word.charAt(0)) // Get the first letter of each word
                    .join("") // Join them together
                    .toUpperCase()}{" "}
                  {/* Convert to uppercase */}
                </span>
              </div>
              <div className="user_welcome">
                <span>Hello {user?.user_name}</span>
              </div>
            </div>
          </div>

          {/* Recent Files Section */}
          <RecentFiles recentfolders={recentfolders} />

          {/* Shortcuts Section */}
          {user?.user_role?.toLowerCase() !== "client" && <Shortcuts />}
          {user?.user_role?.toLowerCase() === "client" && <Notification recentnotifications={recentnotifications} />}
        </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
